import { createFileRoute } from '@tanstack/react-router';
import { ProfilPage } from '@pages/profil';

export const Route = createFileRoute('/profil')({
  component: ProfilPage,
});
